import React, { useState } from 'react';
import { connect } from "react-redux";
import ReceiptTransactions from './receipt/ReceiptTransactions.js';
import ShipmentTransaction from './shipment/ShipmentTransaction.js';
import AllTransaction from './alltrans/AllTransaction.js';
import EDITransaction from './editrans/EDITransaction.js';
import WebTransactions from './weborder/WebTransactions.js';
import CustomerTransactions from './customer/CustomerTransactions.js';
import WMItemDetailsWithCustomer from './items/WMItemDetailsWithCustomer.js';
import WMLotDetailsWithCustomer from './lots/WMLotDetailsWithCustomer.js';
import WMSubLotDetailsWithCustomer from './sublots/WMSubLotDetailsWithCustomer.js';
import WMLocationDetails from './locations/WMLocationDetails.js';
import WMChargesDetails from './charges/WMChargesDetails.js';
import IMCratesDetails from './crates/IMCratesDetails.js';

import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { buildTransTabColoring } from './transColoringHelpers';

const initialTabVisibility = {
  receipts: true,
  shipment: true,
  edi: true,
  web: true,
  customer: true,
  items: true,
  lots: true,
  sublots: true,
  locations: true,
  uninvChg: true,
};

const tabDefaultsToVisibility = (flag) => {
  switch (flag) {
    case 'A': return { receipts: true, shipment: true };
    case 'B': return { receipts: true, shipment: false };
    case 'C': return { receipts: false, shipment: true };
    case 'D': return { receipts: false, shipment: false };
    default: return { receipts: true, shipment: true };
  }
};

const transTabDefaultsToIndex = (flag) => {
  switch (flag) {
    case 'R': return 0; // Receipts
    case 'S': return 1; // Shipment
    case 'A': return 2; // All Trans
    default: return 0;
  }
};

const WMTransactionManagement = (props) => {
  const [tabVisibility, setTabVisibility] = useState(initialTabVisibility);
  const [defaultSelectedIndex, setDefaultSelectedIndex] = useState(0);
  const [itemTabColoring, setItemTabColoring] = useState(null);
  const [transTabColoring, setTransTabColoring] = useState(null);

  const handleProfileApply = (profile) => {
    if (!profile) {
      setTabVisibility(initialTabVisibility);
      setDefaultSelectedIndex(0);
      setItemTabColoring(null);
      setTransTabColoring(null);
      return;
    }
    const tabDefaults = tabDefaultsToVisibility(profile.TabDefaults);
    setTabVisibility({
      receipts: tabDefaults.receipts,
      shipment: tabDefaults.shipment,
      edi: profile.EdiOrdersTab === 'Y',
      web: profile.WebOrdersTab === 'Y',
      customer: profile.CustomersTab === 'Y',
      items: profile.ItemTab === 'Y',
      lots: profile.LotTab === 'Y',
      sublots: profile.SubLotTab === 'Y',
      locations: profile.LocationTab === 'Y',
      uninvChg: profile.UninvoicedChargesTab === 'Y',
    });
    setDefaultSelectedIndex(transTabDefaultsToIndex(profile.TransTabDefaults));
    const coloring = profile.ItemTabUseColors === 'Y' ? {
      pendingLevel: profile.ItemTabPendingLevel != null && profile.ItemTabPendingLevel !== '' ? Number(profile.ItemTabPendingLevel) : null,
      pendingColor: profile.ItemTabPendingColor || null,
      warningLevel: profile.ItemTabWarningLevel != null && profile.ItemTabWarningLevel !== '' ? Number(profile.ItemTabWarningLevel) : null,
      warningColor: profile.ItemTabWarningColor || null,
    } : null;
    console.log('[ItemTabColoring] profile applied', {
      ItemTabUseColors: profile.ItemTabUseColors,
      ItemTabPendingLevel: profile.ItemTabPendingLevel,
      ItemTabPendingColor: profile.ItemTabPendingColor,
      ItemTabWarningLevel: profile.ItemTabWarningLevel,
      ItemTabWarningColor: profile.ItemTabWarningColor,
      computed: coloring,
    });
    setItemTabColoring(coloring);
    const transColoring = buildTransTabColoring(profile);
    console.log('[TransTabColoring] profile applied', {
      TransTabUseColors: profile.TransTabUseColors,
      TransTabBasisDate: profile.TransTabBasisDate,
      TransTabPendingLevel: profile.TransTabPendingLevel,
      TransTabPendingColor: profile.TransTabPendingColor,
      TransTabWarningLevel: profile.TransTabWarningLevel,
      TransTabWarningColor: profile.TransTabWarningColor,
      computed: transColoring,
    });
    setTransTabColoring(transColoring);
  };

  const tabKey = Object.values(tabVisibility).map(v => (v ? '1' : '0')).join('') + `-${defaultSelectedIndex}`;

  return (
    <div className="wm-tab-container">
      <TabPanel key={`wm-tabs-${tabKey}`} defaultSelectedIndex={defaultSelectedIndex} >
        <TabItem title="Receipts" visible={tabVisibility.receipts} style={{ paddingTop: '4px !important' }}>
          <ReceiptTransactions transTabColoring={transTabColoring} />
        </TabItem>
        <TabItem title="Shipment" visible={tabVisibility.shipment} style={{ paddingTop: '4px !important' }}>
          <ShipmentTransaction transTabColoring={transTabColoring} />
        </TabItem>
        <TabItem title="All Trans" style={{ paddingTop: '4px !important' }}>
          <AllTransaction transTabColoring={transTabColoring} />
        </TabItem>
        <TabItem title="EDI-Trans" visible={tabVisibility.edi} style={{ paddingTop: '4px !important' }}>
          <EDITransaction onProfileApply={handleProfileApply} />
        </TabItem>
        <TabItem title="Web-Order" visible={tabVisibility.web} style={{ paddingTop: '4px !important' }}>
          <WebTransactions onProfileApply={handleProfileApply} />
        </TabItem>
        <TabItem title="Customer" visible={tabVisibility.customer} style={{ paddingTop: '4px !important' }}>
          <CustomerTransactions />
        </TabItem>
        <TabItem title="Items" visible={tabVisibility.items} style={{ paddingTop: '4px !important' }}>
          <WMItemDetailsWithCustomer itemTabColoring={itemTabColoring} />
        </TabItem>
        <TabItem title="Lots" visible={tabVisibility.lots} style={{ paddingTop: '4px !important' }}>
          <WMLotDetailsWithCustomer />
        </TabItem>
        <TabItem title="SubLots" visible={tabVisibility.sublots} style={{ paddingTop: '4px !important' }}>
          <WMSubLotDetailsWithCustomer />
        </TabItem>
        <TabItem title="Locations" visible={tabVisibility.locations} style={{ paddingTop: '4px !important' }}>
          <WMLocationDetails />
        </TabItem>
        <TabItem title="UnInv Chg" visible={tabVisibility.uninvChg} style={{ paddingTop: '4px !important' }}>
          <WMChargesDetails />
        </TabItem>
        <TabItem title="Crates" style={{ paddingTop: '4px !important' }}>
          <IMCratesDetails />
        </TabItem>
      </TabPanel>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(WMTransactionManagement);
